import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslations } from 'next-intl';

import { $api, errorHandler, globalConst } from 'modules/global';

import { profileConst } from '..';

export function useSaveAvatar(onClose: () => void) {
  const t = useTranslations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (image?: string | null) => {
      const { data } = await $api.post(`/profile-image-change`, undefined, {
        params: { image }
      });

      return data;
    },
    onSuccess: async () => {
      await Promise.allSettled([
        queryClient.invalidateQueries({ queryKey: [profileConst.queryKeys.USER_PROFILE_INFO] }),
        queryClient.invalidateQueries({ queryKey: [globalConst.queryKeys.USER_DATA] })
      ]);

      onClose();

      message.success(t('saqlandi'));
    },
    onError: errorHandler()
  });
}
